var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactivePatient({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19289_78393",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 14,
    height: 14
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19289_78393)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.538 13.1974L10.0068 11.6661H2.33594V10.0328C2.33594 9.70226 2.42101 9.39844 2.59115 9.12135C2.76128 8.84427 2.98733 8.63281 3.26927 8.48698C3.70677 8.26337 4.15156 8.08351 4.60365 7.9474C5.05573 7.81128 5.5151 7.7092 5.98177 7.64115L0.804688 2.46406L1.63594 1.63281L12.3693 12.3661L11.538 13.1974ZM3.5026 10.4995H8.8401L7.0901 8.74948H7.0026C6.45816 8.74948 5.91858 8.8151 5.38385 8.94635C4.84913 9.0776 4.31927 9.27448 3.79427 9.53698C3.70677 9.58559 3.63628 9.65365 3.58281 9.74115C3.52934 9.82865 3.5026 9.92587 3.5026 10.0328V10.4995ZM10.7359 8.48698C11.0179 8.62309 11.2415 8.82969 11.4068 9.10677C11.572 9.38385 11.6595 9.68281 11.6693 10.0036L9.7151 8.04948C9.8901 8.11753 10.0627 8.18559 10.2328 8.25365C10.403 8.3217 10.5707 8.39948 10.7359 8.48698ZM8.28594 6.62031L7.42552 5.7599C7.64913 5.6724 7.82899 5.52899 7.9651 5.32969C8.10122 5.13038 8.16927 4.9092 8.16927 4.66615C8.16927 4.34531 8.05503 4.07066 7.82656 3.84219C7.59809 3.61372 7.32344 3.49948 7.0026 3.49948C6.75955 3.49948 6.53837 3.56753 6.33906 3.70365C6.13976 3.83976 5.99635 4.01962 5.90885 4.24323L5.04844 3.38281C5.27205 3.05226 5.55399 2.79462 5.89427 2.6099C6.23455 2.42517 6.60399 2.33281 7.0026 2.33281C7.64427 2.33281 8.19358 2.56128 8.65052 3.01823C9.10746 3.47517 9.33594 4.02448 9.33594 4.66615C9.33594 5.06476 9.24358 5.4342 9.05885 5.77448C8.87413 6.11476 8.61649 6.3967 8.28594 6.62031Z",
    fill: "#D31759"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactivePatient);
export default __webpack_public_path__ + "static/media/inactive-patient.71938b18ed1d56c104eaf723663b978f.svg";
export { ForwardRef as ReactComponent };